module.exports = __webpack_public_path__ + "img/notifications--icon.beb06d4d.svg";